module.exports = __webpack_public_path__ + "1f4cda70180ae2dd9f0c106d6da2b508.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-21.png
// module id = 2530
// module chunks = 0